import { render, staticRenderFns } from "./TemplateGreed.vue?vue&type=template&id=926b890a&scoped=true&"
import script from "./TemplateGreed.vue?vue&type=script&lang=js&"
export * from "./TemplateGreed.vue?vue&type=script&lang=js&"
import style0 from "./TemplateGreed.vue?vue&type=style&index=0&id=926b890a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926b890a",
  null
  
)

export default component.exports